<ngx-spinner type="ball-scale-multiple"></ngx-spinner>
<p-toast></p-toast>
<app-pass-upload-errors></app-pass-upload-errors>
<router-outlet></router-outlet>
